import { useState } from 'react';

export const useLocalStorage = ({ key, value }) => {
  const [storedValue] = useState(() => {
  	try {
  		const v = localStorage.getItem(key);
  		if(v)
  			return JSON.parse(v);
  		else {
  			localStorage.set(key, JSON.stringify(value));
  			return value;
  		}
  	} catch(ex){
  		return value;
  	}
  });

  const setValue = (val) => {
  	try {
  		localStorage.setItem()
  	} catch(ex) {}

  }

  return [storedValue, setValue];
 
}